import { IForm } from 'core-components/classes/models/IForm'
import {
  ICrudImplementation,
  IDataProviderFilter,
  IDataProviderSort,
  TConnectorCreateFn,
  TConnectorDeleteFn,
  TConnectorUpdateFn,
} from 'core-components/types'
import { Crud } from 'src/core/types/Crud'
import { CrudInnerStorageFetcher } from 'src/core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'src/core/types/crudStore'

export interface ICreateCrudProps<T> {
  key: string
  formId: number
  code: string
  fetcher?: ICrudImplementation<T>
  keyField?: string
  hierarchyField?: string
  hierarchyRoot?: string | number | null
  pageSize?: number
  defaultFilter?: IDataProviderFilter
  defaultSort?: IDataProviderSort | IDataProviderSort[]
  skipSubscribersCallOnFilterChange?: boolean
  skipPageTransforming?: boolean
  connectorCreateFn?: TConnectorCreateFn<T>
  connectorUpdateFn?: TConnectorUpdateFn<T>
  connectorDeleteFn?: TConnectorDeleteFn<T>
}

const createCrudByConfig = <T = IForm>(data: ICreateCrudProps<T>) => {
  const keyField = data.keyField || 'EntryId'
  const pageSize = data.pageSize || 10000
  const skipSubscribersCallOnFilterChange = data.skipSubscribersCallOnFilterChange || false
  const skipPagingTransform = data.skipPageTransforming || false
  const fetcher =
    data.fetcher ||
    new CrudInnerStorageFetcher<T>(keyField, {
      formId: data.formId,
      code: data.code,
    })

  return new Crud<T>({
    fetcher,
    keyField,
    skipSubscribersCallOnFilterChange,
    skipPagingTransform,
    hierarchyField: data.hierarchyField,
    hierarchyRoot: data.hierarchyRoot,
    defaultPaging: { page: 0, pageSize },
    defaultFilter: data.defaultFilter,
    defaultSort: data.defaultSort,
    connectorCreateFn: data.connectorCreateFn,
    connectorUpdateFn: data.connectorCreateFn,
    connectorDeleteFn: data.connectorDeleteFn,
  })
}

export const createCrud = <T = IForm>(data: ICreateCrudProps<T>) => {
  const crud = createCrudByConfig<T>(data)
  CrudStore.add(crud, data.key)
}
